module.exports = __webpack_public_path__ + "static/img/index@2x.8e1d86fa.png";